import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { HealthServicesLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const Health_MTMTB_Hospital = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
            <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {HealthServicesLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2 bas">
                    <h3 className="fontSizeClass"> {t("MTMTB Hospital")} </h3>
                  </div>
                  <div className=" health-dept-table" style={{ width: "100%" }}>
                    <table
                      width="95%"
                      border={0}
                      align="center"
                      cellPadding={2}
                      cellSpacing={2}
                      className="table table-bordered officials"
                    >
                      <tbody>
                        <tr
                          bgcolor="#302ba0"
                          tabIndex={0}
                          align="center"
                          valign="middle"
                          style={{ color: "white", fontWeight: "bold" }}
                        >
                          <td
                            width="27%"
                            className="text-white tble-brder-left"
                          >
                            {t("Sl. No")}.
                          </td>
                          <td width="52%" className="text-white">
                            {t("Name")}
                          </td>
                          <td
                            width="21%"
                            className="text-white tble-brder-right"
                          >
                            {t("No of Beds")}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="center" valign="top">
                          <td width="27%" align="center">
                            1
                          </td>
                          <td width="52%" align="center">
                            {t("MTMTB Hospital")}
                          </td>
                          <td width="21%" align="center">
                            {t("150")}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Health_MTMTB_Hospital;
